const NAME = "PROCESSES_BY_PATH";

export default NAME;
